module.exports = __webpack_public_path__ + "img/storeNum3.d74b1631.png";